var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemAirplane = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.226 19.773 6.14 13.25c.013-.046.018-.093.03-.139h4.72a1.11 1.11 0 1 0 0-2.222h-4.72c-.012-.046-.017-.093-.03-.139L4.244 4.239l15.534 7.76zm16.546-9.76L5.218 2.241A2.2 2.2 0 0 0 4.221 2C2.834 2 1.653 3.347 2.094 4.851l1.912 6.523c.12.41.12.843 0 1.25L2.094 19.15C1.653 20.653 2.834 22 4.22 22c.326 0 .665-.074.997-.241l15.554-7.772c1.636-.818 1.636-3.156 0-3.974"
})));
export default SvgGemAirplane;